import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: [_vm.wrapperClass, _vm.columnsClass],
      attrs: { "data-qa": _vm.dataQa },
    },
    _vm._l(_vm.items, function (item) {
      return _c(
        VBtn,
        {
          key: item.key,
          staticClass:
            "header-town-list__item text--text py-3 d-block justify-start break-inside-avoid h-auto",
          attrs: {
            "data-qa": "dialog_town_item",
            color: "text",
            text: "",
            block: "",
          },
          on: {
            click: function ($event) {
              return _vm.$emit("select", item.data)
            },
          },
        },
        [
          _c("div", { class: item.textClass }, [
            _vm._v("\n      " + _vm._s(item.name) + "\n    "),
          ]),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }